export default __webpack_public_path__ + "static/media/label-dosug.65c102f5.svg";